<app-toolbar #toolbar [pesquisaVisivel]="false"></app-toolbar>
  <mat-divider></mat-divider>
<mat-card  class="container">
	<mat-toolbar color="primary">Mural de Avisos</mat-toolbar>
	<mat-card-content class="container-content">	
    <span *ngIf="mensagensMural.length === 0">Você não possui notificações!</span>		
		<div *ngFor="let mensagem of mensagensMural" [class]="mensagem.dt_hr_leitura === null ? 'mensagem-pendente' : 'mensagem-lida'" (click)="abrirMensagem(mensagem)">
      <h4>{{mensagem.titulo}}</h4>
      <p>{{mensagem.mensagem}}</p>
      <span>{{mensagem.dt_hr_envio | date:'dd/MM/yyyy HH:mm' }}</span>
      <mat-divider></mat-divider>
    </div>
	</mat-card-content>
</mat-card>